/**
 * Retourne la liste de types de formation pertinente pour filtrer les
 * étudiants d'une classe donnée.
 *
 * Une classe dont le code finit par "-CS" appartient à la Formation Continue
 * (Cours du Soir) : on ne veut alors charger QUE les étudiants `type_formation='CS'`.
 *
 * Pour toute autre classe, on charge les étudiants FI (Formation Initiale)
 * et DD (Double Diplôme), excluant ainsi les CS (qui ont leur classe dédiée).
 *
 * Centralisé ici pour garder un comportement cohérent sur toutes les pages
 * de saisie (devoirs, examens, consultation, délibération, relevés, OCR).
 */
export const typeFormationForClasse = (classe?: string | null): string =>
  classe && classe.endsWith('-CS') ? 'CS' : 'FI,DD';

/**
 * Variante pour les écrans qui filtrent par nom d'option (et pas par code de
 * classe). Les options CS dupliquées portent le nom `XXX (CS)` (suffixe ajouté
 * par `dupliquer_pour_cs`) : on bascule sur `CS` quand ce marqueur est présent.
 */
export const typeFormationForOption = (option?: string | null): string =>
  option && /\(CS\)\s*$/.test(option) ? 'CS' : 'FI,DD';
